import { LanguageCode } from "./localization/languages/types";
import { getSuiteSlug } from "./suites";

type UrlForLanguage = { [key in LanguageCode]: string };

const raqSpecificUrl: UrlForLanguage = {
  en: "/request-quote-s",
  fr: "/fr/demander-un-devis-s",
  es: "/es/solicite-presupuesto-s",
  "pt-br": "/pt-br/solicite-um-orcamento-s",
  de: "/de/angebot-anfordern-s"
};

export function getItemSpecificRAQ(
  languageCode: LanguageCode,
  slug: string | undefined | null = undefined
): string {
  return [raqSpecificUrl[languageCode], slug].filter((i) => !!i).join("/");
}

export function getCruiseSpecificRAQ(
  languageCode: LanguageCode,
  cruiseCode: string
): string {
  return getItemSpecificRAQ(languageCode, `${cruiseCode.toUpperCase()}`);
}

export function getSuiteSpecificRAQ(
  languageCode: LanguageCode,
  cruiseCode: string | undefined,
  shipId: string | undefined,
  suiteCode: string | undefined
): string | undefined {
  if (!cruiseCode || !shipId || !suiteCode) return undefined;

  const suiteSlug = getSuiteSlug(shipId, suiteCode);
  const fullSlug = `${cruiseCode.toUpperCase()}/${suiteSlug}`;
  return getItemSpecificRAQ(languageCode, fullSlug);
}
